import React from 'react';
import cn from 'classnames';

const LearnerSectionStats = ({
  sectionViews,
  showUserTime,
  sectionArray,
  totalSectionsTime,
}) => {
  const RenderSections = () => {
    return sectionArray.map(section => (
      <tr key={section.section.title}>
        <td className="DataTable-name wide">
          <b className="DataTable-label">
            {t('lesson_analytics.section.learner.title')}
          </b>
          {section.section.title || t('lesson_analytics.section.default_title')}
        </td>
        <td>
          <b className="DataTable-label">
            {t('lesson_analytics.section.learner.views')}
          </b>
          {section.sectionViews}
        </td>
        {showUserTime && (
          <td>
            <b className="DataTable-label">
              {t('lesson_analytics.section.learner.time_spent')}
            </b>
            {section.timeSpentOnSection}
          </td>
        )}
      </tr>
    ));
  };

  return (
    <>
      <header>
        <h3>{t('lesson_analytics.section.learner.stats')}</h3>
      </header>
      <table
        className={cn('DataTable Table LessonAnalytics-Table', {
          wide: showUserTime,
          small: !showUserTime,
        })}
      >
        <thead>
          <tr>
            <th className="DataTable-name wide">
              {t('lesson_analytics.section.learner.title')}
            </th>
            <th>{t('lesson_analytics.section.learner.views')}</th>
            {showUserTime && (
              <th>{t('lesson_analytics.section.learner.time_spent')}</th>
            )}
          </tr>
        </thead>
        <tbody>
          <RenderSections />
          <tr className="footer fw-b">
            <td className="DataTable-name wide">
              <b className="DataTable-label">
                {t('lesson_analytics.section.learner.title')}
              </b>
              {t('lesson_analytics.section.learner.lesson_totals')}
            </td>
            <td>
              <b className="DataTable-label">
                {t('lesson_analytics.section.learner.views')}
              </b>
              {sectionViews}
            </td>
            {showUserTime && totalSectionsTime && (
              <td>
                <b className="DataTable-label">
                  {t('lesson_analytics.section.learner.time_spent')}
                </b>
                {totalSectionsTime}
              </td>
            )}
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default LearnerSectionStats;
